import $ from 'jquery';

const restockNotification = $( '.button__restock-notification' );
let restock_notification_message = $( '.add-to-cart__message' );


restockNotification.on( 'click', (e) => {
	let endpoint;

	if ( $(e.target).hasClass('inactive') ) {
		endpoint = psh_vars.rest_route.psh_request_restock_notification;
	}

	if ( $(e.target).hasClass('active') ) {
		endpoint = psh_vars.rest_route.psh_unsubscribe_restock_notification;
	}

	if ( ! endpoint ) {
		return false;
	}

	const pshNumber = $(e.target).data('psh-number');

	$.ajax( {
		type: "POST",
		url: endpoint,
		data: {
			psh_number: pshNumber,
		},
		success: function (data) {
			let message_style = data.success ? 'success' : 'error';

			restock_notification_message.html( data.message );
			restock_notification_message.addClass( message_style );
			restock_notification_message.show();

			if ( data.success ) {
				$(e.target).removeClass('active');
				$(e.target).removeClass('inactive');

				$(e.target).addClass(data.button_class);
				$(e.target).html(data.button_label);
			}

			setTimeout( function () {
				restock_notification_message.hide();
				restock_notification_message.removeClass( 'success error' );
			}, 4000 );
		},
	} );
} );